/* eslint-disable spire/fenced-imports */
/* eslint-disable camelcase */
/* eslint-disable ordered-imports/ordered-imports */
import ADILiveChatComponent from "@NA/Components/ADILiveChatComponent";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import Zone from "@insite/client-framework/Components/Zone";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { StyledButton } from "@insite/mobius/Clickable";
import { Button, Link, Typography } from "@insite/mobius/index";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: CustomApplicationState) => {
    const { search } = getLocation(state);
    const { query } = parseQueryString(search) as unknown as any;

    return {
        query,
        isAuthenticated: state.context.session.isAuthenticated,
    };
};

export interface ADINoSearchResultsStyles {
    buttonStyles?: ButtonPresentationProps;
    noSearchResultsMainContainer?: InjectableCss;
    headingTextNoSearch?: InjectableCss;
    bottomSection?: InjectableCss;
    lastTextContainer?: InjectableCss;
}

export const adiNoSearchResultsStyles: ADINoSearchResultsStyles = {
    lastTextContainer: {
        css: css`
            width: 100%;
            text-align: center;
            font-size: 16px;
            font-weight: normal;
            padding: 0px 15px;
            display: inline-block;
            color: ${getColor("text.main")};
            .helpCenterLink {
                > ${TypographyStyle} {
                    text-decoration: underline;
                    &:hover {
                        color: ${getColor("primary")};
                        text-decoration: underline;
                    }
                }
            }
        `,
    },
    bottomSection: {
        css: css`
            max-width: 400px;
            margin: 0 auto;
            padding: 30px 0px 65px;
            @media only screen and (max-width: 700px) {
                padding: 30px 0px 45px;
            }
            .clickHereLink {
                font-size: 14px;
                color: ${ADIColors.blue5};
                text-decoration: underline;
                cursor: pointer;
                &:hover {
                    color: ${ADIColors.darkBlue7};
                    text-decoration: underline;
                }
            }
            .fantasticText {
                font-size: 18px;
                font-weight: 700;
            }
            .thankYouText {
                font-size: 14px;
            }
            .didYouFindText {
                font-size: 14px;
                font-weight: normal;
                padding-bottom: 7px;
                display: block;
            }
            .buttonContainer {
                display: flex;
                width: 230px;
                justify-content: space-between;
            }
        `,
    },
    headingTextNoSearch: {
        css: css`
            width: 100%;
            font-size: 36px;
            font-weight: 700;
            color: ${ADIColors.darkBlue1};
            text-align: center;
            line-height: normal;
            padding-left: 15px;
            padding-right: 15px;
            padding-bottom: 34px;
            display: flex;
            flex-direction: column;
            @media only screen and (max-width: 1079px) {
                font-size: 24px;
                padding-top: 34px;
            }
        `,
    },
    noSearchResultsMainContainer: {
        css: css`
            > div[class^="Wrapper"] {
                .wrapgrey {
                    padding: 35px 30px 100px;
                    @media only screen and (min-width: 768px) and (max-width: 1080px) {
                        padding: 35px 30px 50px;
                    }
                    @media only screen and (max-width: 700px) {
                        padding: 12px 15px 24px;
                        border-radius: 0px;
                    }
                    h2 {
                        @media only screen and (max-width: 900px) {
                            font-size: 20px;
                        }
                    }
                    ol {
                        li {
                            @media only screen and (min-width: 768px) and (max-width: 1080px) {
                                padding-bottom: 15px;
                            }
                            @media only screen and (max-width: 900px) {
                                font-size: 14px;
                            }
                        }
                    }
                    ${StyledButton} {
                        > ${TypographyStyle} {
                            &:hover {
                                color: ${getColor("primary")};
                            }
                        }
                    }
                }
            }
        `,
    },
    buttonStyles: {
        css: css`
            display: inline-block;
            background-color: ${getColor("primary")};
            border-radius: 4px;
            color: ${getColor("common.background")};
            font-size: 14px;
            font-weight: normal;
            padding: 0.579em 1em;
            text-decoration: none;
            transition: all 100ms ease-in-out;
            cursor: pointer;
            border: 0;
            box-shadow: 0 1px 0 0 ${ADIColors.lightBlue9};
            min-width: 7.66667em;
            text-align: center;
            &:hover {
                transform: translateY(-3px);
                background-color: ${ADIColors.lightBlue8};
                box-shadow: 0 1px 0 0 ${ADIColors.darkBlue7};
            }
        `,
    },
};

const styles = adiNoSearchResultsStyles;

const CoveoADINoSearchResults = ({ id, isAuthenticated }: Props) => {
    const [showDidYouFind, setShowDidYouFind] = useState(true);
    const [showFantastic, setShowFantastic] = useState(false);
    const [showLink, setShowLink] = useState(false);

    const hideStyledWrapperYes = () => {
        setShowDidYouFind(false);
        setShowFantastic(true);
    };
    const hideStyledWrapperNo = () => {
        setShowDidYouFind(false);
        setShowLink(true);
    };

    // get value from hash params 
    const getHashParam = (key: string) => {
        const hasString = window.location.hash.split('#')[1];
        const urlParams = new URLSearchParams(hasString);
        return urlParams.get(key);
    };

    // get the value of last_query from params
    const showMessages = () => {

        const searchValue = getHashParam("last_query");
        if (!searchValue) {
            return (
                <Typography>
                    {translate(`We’re sorry. There were no products found. `)}
                </Typography>
            );
        }

        const didYouMean = getHashParam("did_you_mean");
        return (
            <>
                <Typography>
                    {translate(`We’re sorry. We couldn’t find “${searchValue}”.`)}
                </Typography>
                {didYouMean && (
                    <Typography>
                        {translate(`Try Searching for: `)} <Link href={`/search?q=${didYouMean}`}>{didYouMean}</Link>
                    </Typography>
                )}
            </>
        );
    };

    return (
        <StyledWrapper {...styles.noSearchResultsMainContainer}>
            <StyledWrapper {...styles.headingTextNoSearch}>
                {showMessages()}
            </StyledWrapper>

            <Zone contentId={id} zoneName="richContent" />

            <StyledWrapper {...styles.bottomSection}>
                {showDidYouFind && (
                    <>
                        <Typography as="h3" className="didYouFindText">
                            {translate("Did you find what you needed?")}
                        </Typography>
                        <StyledWrapper className="buttonContainer">
                            <Button {...styles.buttonStyles} onClick={hideStyledWrapperYes}>
                                {translate("Yes")}
                            </Button>
                            <Button {...styles.buttonStyles} onClick={hideStyledWrapperNo}>
                                {translate("No")}
                            </Button>
                        </StyledWrapper>
                    </>
                )}
                {showFantastic && (
                    <StyledWrapper>
                        <Typography as="h2" className="fantasticText">
                            {translate("Fantastic!")}
                        </Typography>
                        <Typography as="p" className="thankYouText">
                            {translate("Thank you for sharing your feedback with us.")}
                        </Typography>
                    </StyledWrapper>
                )}
                {showLink && (
                    <StyledWrapper>
                        <Typography as="h2" className="fantasticText">
                            {translate("Let us help find what you need.")}
                        </Typography>
                        {!isAuthenticated && (
                            <Link href="/ContactUs" className="clickHereLink">
                                {translate("Click here to contact us.")}
                            </Link>
                        )}
                        <ADILiveChatComponent adiNoSearchResults={true} />
                    </StyledWrapper>
                )}
            </StyledWrapper>

            <StyledWrapper {...styles.lastTextContainer}>
                <Typography>
                    {translate("Still can’t find what you are looking for? Visit our")}{" "}
                    <Link className="helpCenterLink" href="/help-center">
                        {translate("Help Center")}
                    </Link>
                    .
                </Typography>
            </StyledWrapper>
        </StyledWrapper>
    );

};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CoveoADINoSearchResults),
    definition: {
        group: "Product List",
        displayName: "Coveo ADI No Search Results",
    },
};

export default widgetModule;
